import React from 'react';
import insurers from '../../Photos/YMCInsurers.png'
import companies from '../../Photos/YMCCompanies2.png'
import healthCenters from '../../Photos/YMCHealthCenters2.png'
import "../../Styles/Landing.css";
import { motion } from "framer-motion";
import ContactColors from "../../Photos/ContactColors.png"
import { useInView } from "react-intersection-observer";


const itemVariants = {
/*     hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }, */
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1.2,
        ease: "easeOut",
      },
    },
  };
  
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };
  
  function Clients() {
    const { ref, inView } = useInView({
      triggerOnce: true,
      threshold: 0.2,
    });
  
    return (
     
           <div style={{backgroundImage:"url(" + ContactColors + ")",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
<div className='TextStatistical'>
<span><b>  1 de cada 3 muertes en Chile </b></span>se relaciona con <span><b> hábitos modificables</b></span>  como mala alimentación, tabaquismo y el consumo de alcohol.<span><b> Detectarlos a tiempo es clave para prevenir.</b></span> 
</div>
   
      <motion.div
        className="ClientsFlex"
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        
      >
        <motion.div variants={itemVariants} className="ClientsGroup">
          <img alt="" src={insurers} />
          <div className="ClientsTitle">Aseguradoras</div>
          <div className="ClientsText">
            Desarrollamos modelos predictivos de riesgo cardiovascular y
            metabólico, facilitando el diseño e implementación de intervenciones
            preventivas más eficientes.
          </div>
        </motion.div>
  
        <motion.div variants={itemVariants} className="ClientsGroup">
          <img alt="" src={healthCenters} />
          <div className="ClientsTitle">Centros de Salud públicos y privados</div>
          <div className="ClientsText">
            Aplicamos inteligencia de datos para segmentar el riesgo de
            enfermedades crónicas de tu población, facilitando así el acceso a un
            diagnostico precoz y oportuno de sus patologías.
          </div>
        </motion.div>
  
        <motion.div variants={itemVariants} className="ClientsGroup">
          <img alt="" src={companies} />
          <div className="ClientsTitle">Empresas</div>
          <div className="ClientsText">
            Diseñamos campañas de prevención en terreno y a través de nuestro
            portal de salud, fomentando ambientes laborales más saludables.
          </div>
        </motion.div>
      </motion.div> </div> 
    );
  }

export default Clients;